module.exports = __webpack_public_path__ + "static/media/error-page.cf44ee01.svg";